import React, { useEffect, useRef } from "react";

/**
 * Polished journey film: Paddington → Tiffin Girls’ transit/car routes.
 */
export default function HomeTransportStage() {
  const ref = useRef(null);

  useEffect(() => {
    const video = ref.current;
    if (!video) return undefined;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) {
      video.pause();
      return undefined;
    }
    const play = () => video.play().catch(() => {});
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) play();
          else video.pause();
        });
      },
      { threshold: 0.3 }
    );
    observer.observe(video);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="ht-stage ht-stage--simple">
      <div className="ht-stage-visual">
        <video
          ref={ref}
          className="ht-stage-gif"
          muted
          loop
          playsInline
          preload="metadata"
          poster="/home-clips/transport-modes.jpg?v=11"
          aria-label="Transit and car routes from Paddington to Tiffin Girls on the SchoolCatch map"
        >
          <source src="/home-clips/transport-modes.mp4?v=11" type="video/mp4" />
        </video>
      </div>
      <div className="ht-stage-caption">
        <span className="ht-cap ht-cap--bus">Bus</span>
        <span className="ht-cap ht-cap--train">Train</span>
        <span className="ht-cap ht-cap--walk">Walk</span>
        <span className="ht-cap ht-cap--drive">Car</span>
        <p>Real routes from your pin — times for a Monday morning</p>
      </div>
    </div>
  );
}
